module.exports = __webpack_public_path__ + "media/eDVS3_7.c523e9ad.mp4";